import { ApiProperty } from '@nestjs/swagger'

export class TableGraphResponse {
	@ApiProperty({
		type: 'object',
		additionalProperties: {
			type: 'array',
			nullable: false,
			items: {
				type: 'string',
			},
		},
		description: 'Map of table IDs to arrays of connected table IDs',
	})
	edges: {
		[key: string]: string[]
	}
}
